import * as React from 'react';
import { IMagazinePageSection } from 'models/common/section';
import { ISectionImageElement } from 'models/common/sectionimageelement';
import { ISectionTextElement } from 'models/common/sectiontextelement';
import { default as Slider } from 'react-slick';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Link } from 'react-router';
import { formatInteger } from 'helpers/common';

require('./style.css');

interface IProps {
	section: IMagazinePageSection;
	t?: (key: string, options?: any) => string;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ViewType1 extends React.Component<IProps, any> {
	public timer: HTMLElement = undefined;

	constructor(props) {
		super(props);
	}

	public componentDidMount() {
		this.timer.classList.add('active');
	}

	public render() {
		const { elements } = this.props.section.data;
		const { t } = this.props;

		const elementsContent: JSX.Element[] = [];
		elements.map((element, index) => {
			if (index === 0 || index === 3 || index === 6) {
				let minsReadElementIndex = null;
				let titlePartTwoElementIndex = null;
				let mobileImageIndex = null;

				if (index === 0) {
					minsReadElementIndex = 9;
					titlePartTwoElementIndex = 13;
					mobileImageIndex = 16;
				} else if (index === 3) {
					minsReadElementIndex = 10;
					titlePartTwoElementIndex = 14;
					mobileImageIndex = 17;
				} else if (index === 6) {
					minsReadElementIndex = 11;
					titlePartTwoElementIndex = 15;
					mobileImageIndex = 18;
				}

				if ((element as ISectionImageElement).imageUrl) {
					elementsContent.push(
						<div key={'section1_slide' + index} className="singleSlide">
							<div
								className="backgroundDesktop"
								style={{ backgroundImage: `url(${(elements[index] as ISectionImageElement).imageUrl})` }}
							/>
							<div
								className="backgroundMobile"
								style={{ backgroundImage: `url(${(elements[mobileImageIndex] as ISectionImageElement).imageUrl})` }}
							/>
							<div className="singleSlideContainer">
								<div className="textHolder">
									<div className="author">
										<span className="byText">{t('Magazine_Section_Common_By')} </span>
										<span className="text">{(elements[index + 2] as ISectionTextElement).text}</span>
									</div>
									<Link className="title" to={(elements[index + 1] as ISectionTextElement).redirectUrl}>
										<span className="topRow">{(elements[index + 1] as ISectionTextElement).text}</span>
										<span className="botRow">{(elements[titlePartTwoElementIndex] as ISectionTextElement).text}</span>
									</Link>
									<div className="info">
										<div className="time">
											{t('BSPortal_Common_MinsRead', {
												count: formatInteger(
													parseInt((elements[minsReadElementIndex] as ISectionTextElement).text, 10),
												),
											})}
										</div>
										<div className="clear" />
									</div>
								</div>
							</div>
						</div>,
					);
				}
			}
		});

		const settings: any = {
			dots: true,
			infinite: true,
			speed: 710,
			autoplaySpeed: 5400,
			autoplay: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			dotsClass: 'type1dots',
			swipe: false,
			pauseOnHover: false,
			easing: 'cubic-bezier(0.4, 0.0, 0.25, 0.9)',
			afterChange: () => {
				if (!this.timer.classList.contains('active')) {
					this.timer.classList.add('active');
				}
			},
			beforeChange: () => {
				if (this.timer.classList.contains('active')) {
					this.timer.classList.remove('active');
				}
			},
		};

		if (elementsContent.length === 1) {
			settings.arrows = false;
			settings.dots = false;
			settings.autoplay = false;
		}

		return (
			<div className="sectionType1container">
				<div className="sliderHolder">
					<div className="sliderTopText">
						<div className="topTextHolder">
							<div className="sliderTitle">
								<span className="text1">{t('Magazine_Section_Type1_FeaturedStories_Text1')}</span>
								<span className="text2">{t('Magazine_Section_Type1_FeaturedStories_Text2')}</span>
							</div>
							<div className="seeAllText">
								<Link to={(elements[12] as ISectionTextElement).redirectUrl}>
									{t('Magazine_Section_Common_SeeAll')}
									<span />
								</Link>
							</div>
							<div
								className="timer"
								ref={(timer) => {
									this.timer = timer;
								}}
								style={{ display: elementsContent.length === 1 ? 'none' : 'display-block' }}
							/>
							<div className="clear" />
						</div>
					</div>
					<Slider {...settings}>{elementsContent}</Slider>
				</div>
			</div>
		);
	}
}

export { ViewType1 };
